import { Component } from '@angular/core';

import { AuthService } from './_services/auth.service';
import { TokenRegenerationService } from './_services/token-regeneration.service';

@Component({
  selector: 'app-root',
  template: `<router-outlet />`,
})
export class AppComponent {
  title = 'partners';

  constructor(
    private authService: AuthService,
    private tokenRegenerationService: TokenRegenerationService
  ) {
    authService.checkVersion();
    authService.handleTokenInit();
  }
}
